import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=741f3a80&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741f3a80')) {
      api.createRecord('741f3a80', component.options)
    } else {
      api.reload('741f3a80', component.options)
    }
    module.hot.accept("./FormGroup.vue?vue&type=template&id=741f3a80&", function () {
      api.rerender('741f3a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormGroup.vue"
export default component.exports